module.exports = __webpack_public_path__ + "static/media/prepurchaseIco.36b810ce.svg";